// extracted by mini-css-extract-plugin
module.exports = {"btnCircle":"QuestionButton_btnCircle__3ws70"};